import React from "react";
import {Row, Spin} from "antd";

export class SpinOnCenter extends React.Component{
    render(){
        return (<Row style={{width:'100%', height:'100vh'}} align={'middle'} justify={'center'}><Spin size={'large'}/></Row>);
    }
}
